import React from 'react';
import parse from 'html-react-parser';
import ROUTES from '../../helpers/routes';
import { truncateText } from '../../helpers/functions';
import ByLine from '../ByLine';
import { ICategory, IPost, LatestPostsBaseProps } from '../../helpers/interfaces';
import { Link } from 'gatsby';

const LatestPostsBase: React.FC<LatestPostsBaseProps> = ({ authId, toHideCategory, initPosts }) => {
  const getCategoryData = (post: IPost): ICategory | undefined => {
    if (toHideCategory) return undefined;
    const categoryNode = post?.categories?.nodes[0];
    if (categoryNode?.name && categoryNode?.uri) {
      return {
        name: categoryNode.name,
        uri: categoryNode.uri,
        databaseId: categoryNode?.databaseId,
        slug: categoryNode.slug
      };
    }
    return undefined;
  };
  return (
    <>
      {initPosts.map((post: IPost, i: number) => {
        const excerpt = truncateText(post.excerpt ?? post.content ?? '', 90);

        return (
          <div
            className="col-12 col-md-6 col-lg-4 latest-posts-single"
            key={post.databaseId}>
            <div className={`${i !== 0 ? 'border-top' : ''} pt-4 pb-3 h-100 d-flex flex-wrap`}>
              <Link
                to={ROUTES.BLOG.toUrl(post.uri ?? '')}
                className="post-link-white w-100">
                <h3 className="h5 text-dark">
                  <span className="post-link-title">{parse(post.title)}</span>
                </h3>
                <p className="text-gray mb-2 post-link-text">{parse(excerpt.trim())}</p>
              </Link>

              <ByLine
                className="align-self-end"
                author={!authId ? post.author?.node : undefined}
                date={post.date}
                databaseId={post.databaseId}
                category={getCategoryData(post)}
                isAuthorLink={false}
                authorImgLazyLoading
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default LatestPostsBase;
